<template>
  <div id="app">
    <router-view name="header"></router-view>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view />
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

import axios from "axios";
export default {
  name: "app",
  components: {
    FadeTransition,
  },
  mounted() {
    // let vm = this;
    // axios
    //   .get("http://zorion.alpha-innomed.com:4040/api/auth/me")
    //   .then(function (resp) {
    //     if (resp.data.status == "success") {
    //       vm.$store.dispatch("storeToken", resp.data.token);
    //       vm.$store.dispatch("storeUser", resp.data.user);
    //     }
    //   })
    //   .catch(function (err) {
    //     vm.$store.dispatch("storeToken", null);
    //     vm.$store.dispatch("storeUser", null);
    //     vm.$router.push({ name: "register" });
    //   });
  },
};
</script>
